import React from "react";
import PaymentFailedContainer from "../containers/PaymentFailed";
import MainLayout from "../layouts/MainLayout";

const PaymentFailed = () => {
  return (
    <MainLayout>
      <PaymentFailedContainer />
    </MainLayout>
  );
};

export default PaymentFailed;
